import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { SiteProvider } from "./context/SiteContext";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import AboutSubpage from "./pages/AboutSubpage";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Industries from "./pages/Industries";
import IndustryDetail from "./pages/IndustryDetail";
import Compliance from "./pages/Compliance";
import ComplianceDetail from "./pages/ComplianceDetail";
import Resources from "./pages/Resources";
import ResourceModule from "./pages/ResourceModule";
import NewsDetail from "./pages/NewsDetail";
import FaqsPage from "./pages/FaqsPage";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";
import { AuthProvider } from "./admin/AuthContext";
import AdminLayout from "./admin/AdminLayout";
import AdminLogin from "./admin/pages/Login";
import Dashboard from "./admin/pages/Dashboard";
import SettingsAdmin from "./admin/pages/SettingsAdmin";
import NavigationAdmin from "./admin/pages/NavigationAdmin";
import { PagesList, PageEditor } from "./admin/pages/PagesAdmin";
import CollectionList from "./admin/pages/CollectionList";
import CollectionEditor from "./admin/pages/CollectionEditor";
import StatsAdmin from "./admin/pages/StatsAdmin";
import SubmissionsAdmin from "./admin/pages/SubmissionsAdmin";
import MediaAdmin from "./admin/pages/MediaAdmin";
import SeoAdmin from "./admin/pages/SeoAdmin";
import UsersAdmin from "./admin/pages/UsersAdmin";
import PublicationsAdmin from "./admin/pages/PublicationsAdmin";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <SiteProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                {/* ---------- Public site ---------- */}
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/about/who-we-are" element={<AboutSubpage slug="who-we-are" />} />
                  <Route path="/about/mission-and-values" element={<AboutSubpage slug="mission-and-values" />} />
                  <Route path="/about/why-lemur-quality" element={<AboutSubpage slug="why-lemur-quality" />} />
                  <Route path="/about/our-approach" element={<AboutSubpage slug="our-approach" />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/:slug" element={<ServiceDetail />} />
                  <Route path="/industries" element={<Industries />} />
                  <Route path="/industries/:slug" element={<IndustryDetail />} />
                  <Route path="/compliance" element={<Compliance />} />
                  <Route path="/compliance/:slug" element={<ComplianceDetail />} />
                  <Route path="/resources" element={<Resources />} />
                  <Route path="/resources/insights-news" element={<ResourceModule type="insights-news" />} />
                  <Route path="/resources/insights-news/:slug" element={<NewsDetail />} />
                  <Route path="/resources/publications" element={<ResourceModule type="publications" />} />
                  <Route path="/resources/faqs" element={<FaqsPage />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy-policy" element={<Legal slug="privacy-policy" />} />
                  <Route path="/terms-of-use" element={<Legal slug="terms-of-use" />} />
                  <Route path="/cookie-policy" element={<Legal slug="cookie-policy" />} />
                  {/* Legacy redirects */}
                  <Route path="/values" element={<Navigate to="/about/mission-and-values" replace />} />
                  <Route path="/why-choose-us" element={<Navigate to="/about/why-lemur-quality" replace />} />
                  <Route path="/approach" element={<Navigate to="/about/our-approach" replace />} />
                  <Route path="/consulting" element={<Navigate to="/compliance" replace />} />
                  <Route path="/news" element={<Navigate to="/resources/insights-news" replace />} />
                  <Route path="*" element={<NotFound />} />
                </Route>

                {/* ---------- Admin panel ---------- */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="settings" element={<SettingsAdmin />} />
                  <Route path="navigation" element={<NavigationAdmin />} />
                  <Route path="pages" element={<PagesList />} />
                  <Route path="pages/:slug" element={<PageEditor />} />
                  <Route path="stats" element={<StatsAdmin />} />
                  <Route path="submissions" element={<SubmissionsAdmin />} />
                  <Route path="media" element={<MediaAdmin />} />
                  <Route path="seo" element={<SeoAdmin />} />
                  <Route path="users" element={<UsersAdmin />} />
                  <Route path="publications" element={<PublicationsAdmin />} />
                  <Route path=":collection" element={<CollectionList />} />
                  <Route path=":collection/:id" element={<CollectionEditor />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </SiteProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
